import React from "react";
import styled from "styled-components";
import { Heading } from "../common/Heading/Heading";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Tab } from "../common/Tab/Tab";
import { TabsContainer } from "../common/Tab/TabsContainer";
import { Answer } from "../../assets/images/Answer";
import { Book } from "../../assets/images/Book";

const getTabs = (t) => [
  {
    name: "answers",
    title: t("logs.answers"),
    largeTitle: t("logs.answers"),
    icon: <Answer />,
    description: "",
  },
  {
    name: "knowledge-base-ingestions",
    title: t("logs.knowledgeBaseIngestions"),
    largeTitle: t("logs.knowledgeBaseIngestions"),
    icon: <Book />,
    description: "",
  },
];

export const Logs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = getTabs(t);
  const currentPath = location.pathname;
  const currentTabName = currentPath.includes("knowledge-base-ingestions")
    ? "knowledge-base-ingestions"
    : "answers";
  const activeTab = tabs.find((tab) => tab.name === currentTabName) || tabs[0];

  return (
    <Container>
      <ContentWrapper>
        <TitleSection>
          <Heading text={t("logs.logs")} size={1} />
        </TitleSection>

        {/* <TabsContainer>
          {tabs.map((tab) => {
            const { title, icon, name } = tab;

            const tabProps = {
              title,
              icon,
              isActive: activeTab?.name === name,
              setActiveTab: () => navigate(`/logs/${name}`),
              name,
            };
            return <Tab {...tabProps} key={name} />;
          })}
        </TabsContainer> */}

        <Outlet />
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const ContentWrapper = styled.div``;

const TitleSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 2rem;
  flex-direction: column;
  gap: 1rem;
`;
